<template>
  <v-radio-group :value="currentValue" @change="onInput" :label="name">
    <v-radio
            v-for="item in list"
            :key="item"
            :label="`${item}`"
            :value="`${item}`"
    ></v-radio>
  </v-radio-group>
</template>

<script>

  import formListComponent from '../mixins/form_list_component'

  export default {

    name: 'FormRadioButton',

    mixins: [ formListComponent ],

    /**
     * Внешние данные компонента.
     *
     */
    props: {

    },

    /**
     * Данные компонента.
     *
     */
    data() {

      return {

      }
    },

    /**
     * После создания компонента.
     *
     */
    created() {

    },

    /**
     * Отслеживание изменения свойств компонента.
     *
     */
    watch: {

    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     * Методы компонента.
     *
     */
    methods: {

    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/form/FormRadioButton.vue